'use strict';

const request = require('superagent');
const { Promise } = require('es6-promise');
const apiURLBuilder = require('../core/apiURLBuilder');
const constants = require('constants/index');
const { getReferenceCodeByCountry } = require('utilities/multiLanguageHelper');

const defaultParams = {
    header: {},
    query: {},
};

function soap(url, params) {
    return new Promise(function (resolve, reject) {
        request
            .post(url)
            .timeout(constants.DEFAULT_TIMEOUT)
            .send(params.query)
            .end(function (err, res) {
                if (err) {
                    if (err.timeout) {
                        reject(constants.TIMEOUT_ERROR);
                    } else {
                        reject(err.response || err);
                    }
                } else {
                    resolve(res);
                }
            });
    });
}

function get(url, params = defaultParams, contentType = 'json', accept = 'application/json') {
    params.header = apiURLBuilder.isMocked() ? {} : params.header;
    params.header.originCountry = getReferenceCodeByCountry().toUpperCase();

    return new Promise(function (resolve, reject) {
        request
            .get(url)
            .timeout(constants.DEFAULT_TIMEOUT)
            .query(params.query)
            .set(params.header)
            .set('Accept', accept)
            .type(contentType)
            .end(function (err, res) {
                if (err) {
                    if (err.timeout) {
                        reject(constants.TIMEOUT_ERROR);
                    } else {
                        reject(err.response || err);
                    }
                } else {
                    resolve(res);
                }
            });
    });
}

function post(url, params = defaultParams, contentType = 'json', accept = 'application/json') {
    params.header = apiURLBuilder.isMocked() ? {} : params.header;
    params.header.originCountry = getReferenceCodeByCountry().toUpperCase();

    return new Promise(function (resolve, reject) {
        request
            .post(url)
            .send(params.query)
            .type(contentType)
            .set(params.header)
            .set('Accept', accept)
            .end(function (err, res) {
                if (err) {
                    reject(err.response || err);
                } else {
                    resolve(res);
                }
            });
    });
}

function postWithQuery(url, params = defaultParams, contentType = 'json', accept = 'application/json') {
    params.header = apiURLBuilder.isMocked() ? {} : params.header;
    params.header.originCountry = getReferenceCodeByCountry().toUpperCase();

    return new Promise(function (resolve, reject) {
        request
            .post(url)
            .query(params.query)
            .send(params.body)
            .type(contentType)
            .set(params.header)
            .set('Accept', accept)
            .end(function (err, res) {
                if (err) {
                    reject(err.response || err);
                } else {
                    resolve(res);
                }
            });
    });
}

function put(url, params = defaultParams, contentType = 'json') {
    params.header = apiURLBuilder.isMocked() ? {} : params.header;
    params.header.originCountry = getReferenceCodeByCountry().toUpperCase();

    return new Promise(function (resolve, reject) {
        request
            .put(url)
            .send(params.query)
            .type(contentType)
            .set(params.header)
            .end(function (err, res) {
                if (err) {
                    reject(err.response || err);
                } else {
                    resolve(res);
                }
            });
    });
}

const asyncGet = async (
    url,
    params = defaultParams,
    contentType = 'json',
    accept = 'application/json',
    catchError = false
) => {
    const { header, query } = params;
    try {
        const response = await request
            .get(url)
            .timeout(constants.DEFAULT_TIMEOUT)
            .query(query)
            .set(header)
            .set('Accept', accept)
            .type(contentType);

        return response;
    } catch (error) {
        if (catchError) {
            return error.response || error;
        }
        throw error;
    }
};

const asyncPost = async (
    url,
    params = defaultParams,
    contentType = 'json',
    accept = 'application/json',
    catchError = false
) => {
    const { header, query } = params;
    try {
        const response = await request.post(url).send(query).type(contentType).set(header).set('Accept', accept);

        return response;
    } catch (error) {
        if (catchError) {
            return error.response || error;
        }
        throw error;
    }
};

export default {
    asyncGet,
    asyncPost,
    get,
    post,
    postWithQuery,
    put,
    soap,
};
